import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Utils } from '../shared/utility/utils';
import { CommonService } from './common.service';
import jwt_decode from 'jwt-decode';
import { Router } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard  {
	constructor(private cmnServ: CommonService, private router: Router) {}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		// Skip guard for root path to allow MSAL authentication flow
		if (state.url === '/' || state.url === '') {
			return true;
		}

		const token = this.cmnServ.getOauthTokenBehaviorSubject().getValue();
		
		// Check if token exists
		if (!token || !Utils.notNullCondition(token.access_token)) {
			this.cmnServ.fromUrl = state.url;
			this.redirectToLogin();
			return false;
		}

		// Check if token is expired
		if (this.isTokenExpired(token.access_token)) {
			this.handleExpiredToken();
			this.cmnServ.fromUrl = state.url;
			this.redirectToLogin();
			return false;
		}

		return true;
	}

	private isTokenExpired(token: string): boolean {
		try {
			const decodedToken: any = jwt_decode(token);
			if (!decodedToken.exp) {
				return true;
			}
			
			const currentTime = Math.floor(Date.now() / 1000);
			return decodedToken.exp <= (currentTime + 60);
		} catch (error) {
			console.error('Error decoding token:', error);
			return true;
		}
	}

	private handleExpiredToken(): void {
		// Clear all stored tokens
		localStorage.clear();
		sessionStorage.clear();
		
		// Reset common service state
		this.cmnServ.setOauthToken({});
		this.cmnServ.userToken = null;
		
		// Trigger logout event
		this.cmnServ.onLogout.next(true);
	}

	private redirectToLogin(): void {
		this.router.navigate(['/']);
	}
}
